import { render } from "./AdminGroupingRequestsPage.vue?vue&type=template&id=66d49b80"
import script from "./AdminGroupingRequestsPage.vue?vue&type=script&lang=js"
export * from "./AdminGroupingRequestsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__